console.log("client_websites/template0/application.js Loaded");

import "@hotwired/turbo-rails";
// require("@rails/activestorage").start();
// require("local-time").start();

//* Main application
import { application } from "controllers/application";

//* Bootstrap
import "bootstrap/js/dist/collapse"; //* For the Accordions and the adult friendly
import "bootstrap/js/dist/alert"; //* For the adult friendly

//* i18n
import { i18n } from "../../config/i18n";
window.i18n = i18n;

window.Turbo.config.drive.progressBarDelay = 1000; //* Time in ms 1000ms = 1s

//* Lazysizes
import "lazysizes";

//* Stimulus
import textarea_autogrow from "stimulus-textarea-autogrow";
application.register("textarea-autogrow", textarea_autogrow);

import name_that_color from "view_components/name_that_color/index.js";
application.register("name-that-color", name_that_color);

import moving_letters from "view_components/moving_letters/index.js";
application.register("moving-letters", moving_letters);

import scroll_to from "view_components/scroll_to/index";
application.register("scroll-to", scroll_to);

import section_link from "view_components/section_link/index.js";
application.register("section-link", section_link);

import formvalidation_contact from "view_components/formvalidation/contact/index.js";
application.register("formvalidation--contact", formvalidation_contact);

import validation_fixes from "view_components/validation_fixes/index.js";
application.register("validation-fixes", validation_fixes);

import confetti from "view_components/confetti/index.js";
application.register("confetti", confetti);

import easepick from "view_components/easepick/index.js";
application.register("easepick", easepick);

import price_estimate from "view_components/price_estimate/index.js";
application.register("price-estimate", price_estimate);

import availability_calendar from "view_components/availability_calendar/index.js";
application.register("availability-calendar", availability_calendar);

import intl_tel_input from "view_components/intl_tel_input/index.js";
application.register("intl-tel-input", intl_tel_input);

import recaptcha_v2 from "view_components/recaptcha_v2/index.js";
application.register("recaptcha-v2", recaptcha_v2);

import character_counter from "view_components/character_counter/index.js";
application.register("character-counter", character_counter);

import formvalidation_booking from "view_components/formvalidation/booking/index.js";
application.register("formvalidation--booking", formvalidation_booking);

import autosubmit_form_on_recaptcha from "view_components/autosubmit_form_on_recaptcha/index.js";
application.register("autosubmit-form-on-recaptcha", autosubmit_form_on_recaptcha);

import touchspin from "view_components/touchspin/index.js";
application.register("touchspin", touchspin);

import copyable_input from "view_components/copyable_input/index.js";
application.register("copyable-input", copyable_input);

import fit_text from "view_components/fit_text/index.js";
application.register("fit-text", fit_text);

import parallax_divider from "view_components/parallax_divider/index.js";
application.register("parallax-divider", parallax_divider);

import header from "view_components/header/index.js";
application.register("header", header);

import bootstrap_modal from "view_components/modal/bootstrap/dist.js";
application.register("modal--bootstrap", bootstrap_modal);

import offcanvas from "view_components/offcanvas/dist.js";
application.register("offcanvas", offcanvas);

import bootstrap_toast from "view_components/toast/bootstrap/index.js";
application.register("toast--bootstrap", bootstrap_toast);

import connectivity from "view_components/connectivity/index.js";
application.register("connectivity", connectivity);

import print_detect from "view_components/print_detect/index.js";
application.register("print-detect", print_detect);

import popover from "view_components/popover/index.js";
application.register("popover", popover);

import swiper from "view_components/swiper/index.js";
application.register("swiper", swiper);

import development_tools from "view_components/development_tools/index.js";
application.register("development-tools", development_tools);

import analytics_google_initializer from "view_components/analytics/google/initializer/index.js";
application.register("analytics--google--initializer", analytics_google_initializer);

import analytics_google_event from "view_components/analytics/google/event/index.js";
application.register("analytics--google--event", analytics_google_event);

import analytics_initializer from "view_components/analytics/ahoy/initializer/index.js";
application.register("analytics--initializer", analytics_initializer);

import analytics_event from "view_components/analytics/ahoy/event/index.js";
application.register("analytics", analytics_event);

import noscript_cleanup from "view_components/noscript_cleanup/index.js";
application.register("noscript-cleanup", noscript_cleanup);

import visit from "view_components/visit/index.js";
application.register("visit", visit);

import locale_informer from "view_components/locale_informer/index.js";
application.register("locale-informer", locale_informer);

import privacy_cookie_policy from "view_components/privacy/cookie_policy/index.js";
application.register("privacy--cookie-policy", privacy_cookie_policy);

import privacy_content_consent from "view_components/privacy/content_consent/index.js";
application.register("privacy--content-consent", privacy_content_consent);

import privacy_cookie_iframe_manager from "view_components/privacy/cookie_iframe_manager/index.js";
application.register("privacy--cookie-iframe-manager", privacy_cookie_iframe_manager);

import privacy_asset_consent from "view_components/privacy/asset_consent/index.js";
application.register("privacy--asset-consent", privacy_asset_consent);

import privacy_cookie_policy_service_acceptor from "view_components/privacy/cookie_policy/service_acceptor/index.js";
application.register("privacy--cookie-policy--service-acceptor", privacy_cookie_policy_service_acceptor);

import widget from "view_components/widget/index.js";
application.register("widget", widget);

import espa_banner from "view_components/espa_banner/index.js";
application.register("espa-banner", espa_banner);

import visibility from "view_components/visibility/index.js";
application.register("visibility", visibility);

import content_animator from "view_components/content_animator/index.js";
application.register("content-animator", content_animator);

import image_preview from "view_components/image_preview/index.js";
application.register("image-preview", image_preview);

import show_more from "view_components/show_more/index.js";
application.register("show-more", show_more);

import map from "view_components/map/index.js";
application.register("map", map);

import gallery from "view_components/gallery/index.js";
application.register("gallery", gallery);

import hero_gallery_bootstrap from "view_components/hero_gallery/bootstrap/index.js";
application.register("hero-gallery--bootstrap", hero_gallery_bootstrap);

